import { useReactFlow } from '@xyflow/react';
import { useKeyboardShortcut } from '@/features/canvas/engine/hooks/use-keyboard-shortcut';

export interface ZOrderActions {
  onBringToFront: (id: string) => void;
  onSendToBack: (id: string) => void;
  onBringForward: (id: string) => void;
  onSendBackward: (id: string) => void;
}

export function useZOrderShortcuts(actions: ZOrderActions) {
  const { getNodes } = useReactFlow();
  useKeyboardShortcut(
    { keys: [']', '['], meta: true },
    (e) => {
      e.preventDefault();
      const selected = getNodes().filter((n) => n.selected).map((n) => n.id);
      if (selected.length === 0) return;

      const { onBringToFront, onSendToBack, onBringForward, onSendBackward } = actions;

      for (const id of selected) {
        if (e.key === ']' && e.shiftKey) onBringToFront(id);
        else if (e.key === ']') onBringForward(id);
        else if (e.key === '[' && e.shiftKey) onSendToBack(id);
        else onSendBackward(id);
      }
    },
  );
}
